import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=7f2cedf4&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2cedf4",
  null
  
)

export default component.exports